/* Renders its children inside an isolated <iframe> that carries the REAL
 * renderer theme. Isolation matters: the renderer theme defines global :root
 * vars + body/* rules that would otherwise clobber platform-react's tokens.
 * React renders into the frame via a portal, so it's the same component tree —
 * just sandboxed styling. (In-frame clicks are intentionally inert; the user
 * drives the preview from the controls panel.) */
import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { A2_THEME } from "./a2theme";

export function PreviewFrame({ children }: { children: React.ReactNode }) {
  const ref = useRef<HTMLIFrameElement>(null);
  const [mount, setMount] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const frame = ref.current;
    if (!frame) return;
    const doc = frame.contentDocument;
    if (!doc) return;
    doc.open();
    doc.write(
      '<!doctype html><html><head><meta charset="utf-8">' +
        "<style>" + A2_THEME + "</style>" +
        "<style>.gd-a2-mount{padding:24px}</style>" +
        '</head><body><div class="gd-a2-mount" id="gd-mount"></div></body></html>'
    );
    doc.close();
    setMount(doc.getElementById("gd-mount"));
  }, []);

  return (
    <iframe ref={ref} className="gd-frame" title="Live preview">
      {mount ? createPortal(children, mount) : null}
    </iframe>
  );
}
